<template>
  <span>
    <object-link
      v-if="$currentUserCan($permissions.PERM_VIEW_ANY_USERS)"
      :object="user"
    />
    <span v-else>{{ $objectDenomination(user) }}</span>
  </span>
</template>

<script>
import formMixin from "@/mixins/form-mixin";

export default {
  name: "user",

  components: {},

  mixins: [formMixin],

  props: {
    user: {
      type: Object,
      description: "User",
    },
  },

  data() {
    return {};
  },

  setup() {},

  created() {},

  methods: {},

  watch: {
    user(user) {},
  },
};
</script>
